import { ChangeTracker } from '../../common/models/hooks/ChangeTracker';
import { BillingGroup, MinBillingGroup } from '../../common/models/BillingGroup';

export function BillingGroupToMinBillingGroup(c: BillingGroup): MinBillingGroup {
  return {
    id: c.id,
    clientID: c.clientID,
    name: c.name,
    primaryContactID: c.primaryContactID,
    address1: c.address1,
    address2: c.address2,
    address3: c.address3,
    suburb: c.suburb,
    state: c.state,
    postcode: c.postcode,
    country: c.country,
    description: c.description,
  };
}

export const DefaultMinBillingGroup: MinBillingGroup = {
  id: 0,
  clientID: 0,
  name: '',
  primaryContactID: 0,
  address1: '',
  address2: '',
  address3: '',
  suburb: '',
  state: '',
  postcode: '',
  country: '',
  description: '',
};

export const DefaultMinBillingGroupNoChanges: ChangeTracker<MinBillingGroup> = {
  id: false,
  clientID: false,
  name: false,
  primaryContactID: false,
  address1: false,
  address2: false,
  address3: false,
  suburb: false,
  state: false,
  postcode: false,
  country: false,
  description: false,
};
